import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Form, Row, Col } from "react-bootstrap";
import { zodResolver } from "@hookform/resolvers/zod";

import FormField from "../../../ui/FormField";
import ErrorMessage from "../../../ui/ErrorMessage";
import formEditStroskovnoMestoSchema from "../../../../config/formEditStroskovnoMesto";

import { useEditStroskovnaMestaClanice } from "../../../../services/ProjectDetails/financeAPI";

const PosameznoStroskovnoMestoEditForm = ({
  stroskovnoMestoPosamezno,
  setIsEditing,
}) => {
  const { id } = useParams();
  const schema = useMemo(() => formEditStroskovnoMestoSchema, []);

  const {
    mutate: editStroskovnoMesto,
    isPending: isPendingEdit,
    isError,
    error,
    reset: resetMutationError,
  } = useEditStroskovnaMestaClanice(id);

  const {
    handleSubmit,
    register,
    formState: { errors, isDirty },
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      stroskovnoMesto: stroskovnoMestoPosamezno?.stroskovnoMesto,
      stroskovniNosilec: stroskovnoMestoPosamezno?.stroskovniNosilec,
    },
  });

  const onSubmit = (data) => {
    const payload = {
      id: stroskovnoMestoPosamezno?.id,
      stroskovnoMesto: data.stroskovnoMesto,
      stroskovniNosilec: data.stroskovniNosilec,
    };

    editStroskovnoMesto(payload, {
      onSuccess: () => {
        setIsEditing(false);
      },
      onError: () => setTimeout(() => resetMutationError(), 3000),
    });
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)} className="pb-3">
      <Row>
        <Col md={5}>
          <FormField
            label="Stroškovno mesto"
            showLabel={false}
            formControlType="text"
            register={register("stroskovnoMesto")}
            validationError={errors.stroskovnoMesto?.message}
          />
        </Col>
        <Col md={5}>
          <FormField
            label="Stroškovni nosilec"
            showLabel={false}
            formControlType="text"
            register={register("stroskovniNosilec")}
            validationError={errors.stroskovniNosilec?.message}
          />
        </Col>
        <Col md={2}>
          <button
            type="submit"
            className="btn btn-primary mt-3"
            disabled={!isDirty || isPendingEdit}
          >
            {isPendingEdit ? "Shranjevanje..." : "Shrani"}
          </button>
          <button
            type="button"
            className="btn btn-secondary mt-3 ms-2"
            onClick={() => setIsEditing(false)}
          >
            Prekliči
          </button>
        </Col>
      </Row>
      {isError && <ErrorMessage message={error.message} />}
    </Form>
  );
};

export default PosameznoStroskovnoMestoEditForm;
